var _defs, _g, _script;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuthInfinite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "e7xpoug7ckgc1",
    viewBox: "0 0 274 248",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    width: 600,
    height: 543,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7xpoug7ckgc6-fill",
    x1: 248.2,
    y1: 163.3,
    x2: -66.7,
    y2: 90.2,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc6-fill-0",
    offset: "0%",
    stopColor: "rgb(2,23,144)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc6-fill-1",
    offset: "79%",
    stopColor: "rgba(2,23,144,0)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e7xpoug7ckgc7-fill",
    cx: 0,
    cy: 0,
    r: 87.2,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(128 97)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc7-fill-0",
    offset: "0%",
    stopColor: "rgba(255,255,255,0.52)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc7-fill-1",
    offset: "100%",
    stopColor: "rgba(255,255,255,0.37)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7xpoug7ckgc8-fill",
    x1: 52.6,
    y1: 37.2,
    x2: 232.4,
    y2: 103.1,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc8-fill-0",
    offset: "25%",
    stopColor: "rgba(50,119,102,0)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc8-fill-1",
    offset: "100%",
    stopColor: "rgba(158,0,255,0.33)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7xpoug7ckgc9-stroke",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    spreadMethod: "pad",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc9-stroke-0",
    offset: "21%",
    stopColor: "rgba(4,13,27,0)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc9-stroke-1",
    offset: "49%",
    stopColor: "rgb(0,42,106)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7xpoug7ckgc11-fill",
    x1: 207.9,
    y1: 156.1,
    x2: 493.6,
    y2: 73.4,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc11-fill-0",
    offset: "0%",
    stopColor: "rgba(2,23,144,0.88)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc11-fill-1",
    offset: "75%",
    stopColor: "rgba(2,23,144,0)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e7xpoug7ckgc12-fill",
    cx: 0,
    cy: 0,
    r: 118,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(371 61)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc12-fill-0",
    offset: "0%",
    stopColor: "rgba(255,255,255,0.71)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc12-fill-1",
    offset: "100%",
    stopColor: "rgba(255,255,255,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7xpoug7ckgc13-fill",
    x1: 221.9,
    y1: 77,
    x2: 524.4,
    y2: 44.1,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc13-fill-0",
    offset: "0%",
    stopColor: "rgba(136,234,210,0.25)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc13-fill-1",
    offset: "75%",
    stopColor: "rgba(158,0,255,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7xpoug7ckgc14-stroke",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    spreadMethod: "pad",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc14-stroke-0",
    offset: "49%",
    stopColor: "rgb(0,42,106)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc14-stroke-1",
    offset: "74%",
    stopColor: "rgba(4,13,27,0)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e7xpoug7ckgc15-fill",
    cx: 0,
    cy: 0,
    r: 0,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc15-fill-0",
    offset: "0%",
    stopColor: "rgba(4,13,27,0.75)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc15-fill-1",
    offset: "100%",
    stopColor: "rgba(4,13,27,0)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e7xpoug7ckgc19-fill",
    cx: 0,
    cy: 0,
    r: 154.3,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(250 209)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc19-fill-0",
    offset: "0%",
    stopColor: "rgb(215,150,255)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc19-fill-1",
    offset: "100%",
    stopColor: "rgb(56,41,189)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7xpoug7ckgc20-fill",
    x1: 240.3,
    y1: 209.6,
    x2: 353.1,
    y2: 209.6,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc20-fill-0",
    offset: "0%",
    stopColor: "rgb(19,28,65)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc20-fill-1",
    offset: "100%",
    stopColor: "rgb(4,13,27)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e7xpoug7ckgc21-fill",
    cx: 0,
    cy: 0,
    r: 205.9,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(184 247)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc21-fill-0",
    offset: "0%",
    stopColor: "rgb(0,255,192)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc21-fill-1",
    offset: "100%",
    stopColor: "rgb(158,0,255)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7xpoug7ckgc28-stroke",
    x1: 375.6,
    y1: 265.4,
    x2: 428.7,
    y2: 265.4,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc28-stroke-0",
    offset: "0%",
    stopColor: "rgb(229,61,26)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc28-stroke-1",
    offset: "100%",
    stopColor: "rgb(249,95,29)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7xpoug7ckgc29-stroke",
    x1: 18,
    y1: 0,
    x2: -18,
    y2: 0,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc29-stroke-0",
    offset: "0%",
    stopColor: "rgb(228,59,26)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc29-stroke-1",
    offset: "100%",
    stopColor: "rgb(255,104,30)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7xpoug7ckgc30-stroke",
    x1: 18,
    y1: 0,
    x2: -18,
    y2: 0,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc30-stroke-0",
    offset: "0%",
    stopColor: "rgb(255,128,35)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc30-stroke-1",
    offset: "100%",
    stopColor: "rgb(255,166,83)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7xpoug7ckgc31-stroke",
    x1: 375.6,
    y1: 265.4,
    x2: 428.7,
    y2: 265.4,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc31-stroke-0",
    offset: "0%",
    stopColor: "rgb(255,103,2)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc31-stroke-1",
    offset: "100%",
    stopColor: "rgb(255,166,83)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7xpoug7ckgc34-fill",
    x1: 294.1,
    y1: 271.7,
    x2: 400.3,
    y2: 271.7,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc34-fill-0",
    offset: "0%",
    stopColor: "rgba(96,232,251,0.56)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc34-fill-1",
    offset: "100%",
    stopColor: "rgba(46,178,255,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7xpoug7ckgc35-fill",
    x1: 42.6,
    y1: 209,
    x2: 120,
    y2: 209,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc35-fill-0",
    offset: "0%",
    stopColor: "rgba(46,178,255,0)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc35-fill-1",
    offset: "100%",
    stopColor: "rgba(96,208,251,0.3)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7xpoug7ckgc36-fill",
    x1: 437.9,
    y1: 209,
    x2: 360.5,
    y2: 209,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc36-fill-0",
    offset: "0%",
    stopColor: "rgba(46,178,255,0)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc36-fill-1",
    offset: "100%",
    stopColor: "rgba(96,208,251,0.3)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e7xpoug7ckgc37-fill",
    cx: 0,
    cy: 0,
    r: 0,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc37-fill-0",
    offset: "0%",
    stopColor: "rgb(95,208,252)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc37-fill-1",
    offset: "100%",
    stopColor: "rgba(46,178,255,0)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e7xpoug7ckgc38-fill",
    cx: 0,
    cy: 0,
    r: 0,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc38-fill-0",
    offset: "0%",
    stopColor: "rgb(95,208,252)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc38-fill-1",
    offset: "100%",
    stopColor: "rgba(46,178,255,0)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e7xpoug7ckgc41-fill",
    cx: 0,
    cy: 0,
    r: 154.3,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(250 209)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc41-fill-0",
    offset: "0%",
    stopColor: "rgb(212,142,255)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc41-fill-1",
    offset: "100%",
    stopColor: "rgb(49,32,198)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e7xpoug7ckgc42-fill",
    cx: 0,
    cy: 0,
    r: 184.5,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(184 157)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc42-fill-0",
    offset: "0%",
    stopColor: "rgb(157,162,248)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc42-fill-1",
    offset: "100%",
    stopColor: "rgb(158,0,255)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7xpoug7ckgc43-stroke",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    spreadMethod: "pad",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc43-stroke-0",
    offset: "47%",
    stopColor: "rgb(55,36,135)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc43-stroke-1",
    offset: "62%",
    stopColor: "rgb(29,12,115)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e7xpoug7ckgc47-fill",
    cx: 0,
    cy: 0,
    r: 159.8,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 -25)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc47-fill-0",
    offset: "0%",
    stopColor: "rgb(52,38,94)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc47-fill-1",
    offset: "100%",
    stopColor: "rgb(14,17,37)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7xpoug7ckgc51-stroke",
    x1: 336.2,
    y1: 220.8,
    x2: 421.4,
    y2: 220.8,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc51-stroke-0",
    offset: "0%",
    stopColor: "rgb(174,220,253)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc51-stroke-1",
    offset: "100%",
    stopColor: "rgb(211,192,255)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e7xpoug7ckgc61-fill",
    cx: 0,
    cy: 0,
    r: 21.7,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc61-fill-0",
    offset: "45%",
    stopColor: "rgb(252,226,141)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc61-fill-1",
    offset: "49%",
    stopColor: "rgba(252,226,141,0.42)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc61-fill-2",
    offset: "100%",
    stopColor: "rgba(252,226,141,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e7xpoug7ckgc66-filter",
    x: "-400%",
    width: "600%",
    y: "-400%",
    height: "600%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "e7xpoug7ckgc66-filter-blur-0",
    stdDeviation: "2,2",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7xpoug7ckgc67-fill",
    x1: 77,
    y1: 113.7,
    x2: -67.8,
    y2: -100,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc67-fill-0",
    offset: "0%",
    stopColor: "rgb(0,149,202)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc67-fill-1",
    offset: "25%",
    stopColor: "rgb(152,38,251)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc67-fill-2",
    offset: "50%",
    stopColor: "rgb(213,28,126)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc67-fill-3",
    offset: "75%",
    stopColor: "rgb(203,48,62)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc67-fill-4",
    offset: "100%",
    stopColor: "rgb(206,110,39)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7xpoug7ckgc68-fill",
    x1: 77,
    y1: 113.7,
    x2: -67.8,
    y2: -100,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc68-fill-0",
    offset: "0%",
    stopColor: "rgb(26,213,202)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc68-fill-1",
    offset: "25%",
    stopColor: "rgb(190,102,251)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc68-fill-2",
    offset: "50%",
    stopColor: "rgb(251,92,126)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc68-fill-3",
    offset: "75%",
    stopColor: "rgb(241,112,62)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc68-fill-4",
    offset: "100%",
    stopColor: "rgb(244,174,39)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e7xpoug7ckgc70-fill",
    cx: 0,
    cy: 0,
    r: 67.3,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(318 142)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc70-fill-0",
    offset: "0%",
    stopColor: "rgb(230,200,44)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc70-fill-1",
    offset: "52%",
    stopColor: "rgb(233,149,72)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc70-fill-2",
    offset: "100%",
    stopColor: "rgb(242,137,139)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e7xpoug7ckgc72-fill",
    cx: 0,
    cy: 0,
    r: 47.1,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(304 183)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc72-fill-0",
    offset: "0%",
    stopColor: "rgb(34,19,85)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc72-fill-1",
    offset: "100%",
    stopColor: "rgb(78,40,159)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e7xpoug7ckgc73-fill",
    cx: 0,
    cy: 0,
    r: 45.9,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc73-fill-0",
    offset: "0%",
    stopColor: "rgba(255,255,141,0.7)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc73-fill-1",
    offset: "44%",
    stopColor: "rgba(255,255,141,0.3)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc73-fill-2",
    offset: "48%",
    stopColor: "rgba(255,230,110,0.4)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc73-fill-3",
    offset: "100%",
    stopColor: "rgba(255,255,76,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e7xpoug7ckgc75-filter",
    x: "-400%",
    width: "600%",
    y: "-400%",
    height: "600%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "e7xpoug7ckgc75-filter-blur-0",
    stdDeviation: "7,7",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7xpoug7ckgc76-fill",
    x1: 328.5,
    y1: 293.3,
    x2: 349.5,
    y2: 277.7,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc76-fill-0",
    offset: "0%",
    stopColor: "rgb(123,198,255)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc76-fill-1",
    offset: "78%",
    stopColor: "rgb(124,131,221)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7xpoug7ckgc77-fill",
    x1: 321.2,
    y1: 309.8,
    x2: 300.2,
    y2: 325.6,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc77-fill-0",
    offset: "0%",
    stopColor: "rgb(113,194,255)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc77-fill-1",
    offset: "56%",
    stopColor: "rgb(157,213,255)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7xpoug7ckgc78-fill",
    x1: 275.8,
    y1: 289.8,
    x2: 329,
    y2: 250.1,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc78-fill-0",
    offset: "0%",
    stopColor: "rgb(252,254,255)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc78-fill-1",
    offset: "100%",
    stopColor: "rgb(86,160,244)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e7xpoug7ckgc80-filter",
    x: "-400%",
    width: "600%",
    y: "-400%",
    height: "600%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "e7xpoug7ckgc80-filter-blur-0",
    stdDeviation: "7,7",
    result: "result"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e7xpoug7ckgc81-fill",
    cx: 0,
    cy: 0,
    r: 186.6,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(245 199)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc81-fill-0",
    offset: "0%",
    stopColor: "rgb(42,9,129)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc81-fill-1",
    offset: "76%",
    stopColor: "rgb(0,0,101)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc81-fill-2",
    offset: "100%",
    stopColor: "rgb(41,0,248)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e7xpoug7ckgc82-fill",
    cx: 0,
    cy: 0,
    r: 181.8,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(150 98)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc82-fill-0",
    offset: "0%",
    stopColor: "rgb(118,31,161)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc82-fill-1",
    offset: "76%",
    stopColor: "rgb(20,36,101)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc82-fill-2",
    offset: "100%",
    stopColor: "rgb(79,0,248)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7xpoug7ckgc83-fill",
    x1: 115.9,
    y1: 154.7,
    x2: 244.5,
    y2: 154.7,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc83-fill-0",
    offset: "32%",
    stopColor: "rgb(252,254,255)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc83-fill-1",
    offset: "100%",
    stopColor: "rgb(166,200,249)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7xpoug7ckgc89-fill",
    x1: 229.2,
    y1: -18.9,
    x2: 234.4,
    y2: -16.2,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc89-fill-0",
    offset: "0%",
    stopColor: "rgb(91,184,255)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc89-fill-1",
    offset: "74%",
    stopColor: "rgb(91,184,255)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7xpoug7ckgc90-fill",
    x1: 133,
    y1: -68.5,
    x2: 138.2,
    y2: -65.8,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc90-fill-0",
    offset: "0%",
    stopColor: "rgb(91,184,255)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e7xpoug7ckgc90-fill-1",
    offset: "74%",
    stopColor: "rgb(91,184,255)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e7xpoug7ckgc2",
    transform: "translate(-31 -18) scale(.69605)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e7xpoug7ckgc3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e7xpoug7ckgc4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e7xpoug7ckgc5",
    display: "none",
    opacity: 0,
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc6",
    fill: "url(\"#e7xpoug7ckgc6-fill\")",
    stroke: "none",
    d: "M0 162l120 33 120-33V62L120 95 0 62v100z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc7",
    fill: "url(\"#e7xpoug7ckgc7-fill\")",
    stroke: "none",
    d: "M120 95v100L0 162V62l120 33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc8",
    fill: "url(\"#e7xpoug7ckgc8-fill\")",
    stroke: "none",
    d: "M120 95L0 62l120-33 120 33-120 33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc9",
    opacity: 0.5,
    fill: "none",
    stroke: "url(\"#e7xpoug7ckgc9-stroke\")",
    strokeMiterlimit: 10,
    d: "M240 78l-120 33L0 77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "e7xpoug7ckgc10",
    display: "none",
    opacity: 0,
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc11",
    fill: "url(\"#e7xpoug7ckgc11-fill\")",
    stroke: "none",
    d: "M240 162l121 33 120-33V62L361 95 240 62v100z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc12",
    fill: "url(\"#e7xpoug7ckgc12-fill\")",
    stroke: "none",
    d: "M361 95v100l-121-33V62l121 33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc13",
    fill: "url(\"#e7xpoug7ckgc13-fill\")",
    stroke: "none",
    d: "M361 95L240 62l121-33 120 33-120 33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc14",
    opacity: 0.5,
    fill: "none",
    stroke: "url(\"#e7xpoug7ckgc14-stroke\")",
    strokeMiterlimit: 10,
    d: "M481 78l-120 33-121-34"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "e7xpoug7ckgc15",
    display: "none",
    r: 107,
    transform: "translate(240 185)",
    fill: "url(\"#e7xpoug7ckgc15-fill\")",
    stroke: "none",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "e7xpoug7ckgc16",
    transform: "matrix(0 0 0 0 240 381)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "e7xpoug7ckgc17",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc18",
    fill: "#24369F",
    d: "M240 327l121-32v-85l-121 32v85z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc19",
    fill: "url(\"#e7xpoug7ckgc19-fill\")",
    d: "M240 242v85l-120-32v-85l120 32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc20",
    fill: "url(\"#e7xpoug7ckgc20-fill\")",
    d: "M240 179v61l113-30-113-31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc21",
    d: "M240 177l-120 33 120 32 121-32zm0 63l-112-30 112-31 113 31z",
    fill: "url(\"#e7xpoug7ckgc21-fill\")"
  })), /*#__PURE__*/React.createElement("g", {
    id: "e7xpoug7ckgc22",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc23",
    d: "M312 263c0-9-4-15-9-15s-9 6-9 15c0 4 1 8 3 11v16l11-3v-13c3-3 4-7 4-11z",
    fill: "#040D1B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc24",
    d: "M303 248l-4 1c4 1 8 7 8 15 0 4-2 8-4 11v13l-6 2 11-3v-13c3-3 4-7 4-12 0-8-4-14-9-14z",
    fill: "#0F0266"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc25",
    d: "M297 290l6-2v-13c3-3 4-7 4-11 0-8-4-14-8-15-3 3-5 8-5 14 0 4 1 8 3 11v16z",
    fill: "#5FD0FC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "e7xpoug7ckgc26",
    clipPath: "url(#e7xpoug7ckgc32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e7xpoug7ckgc27",
    transform: "matrix(1.17153 .3183 0 1.17153 -177 -172)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc28",
    transform: "translate(2 -1)",
    stroke: "url(\"#e7xpoug7ckgc28-stroke\")",
    strokeWidth: 11,
    d: "M428 259l-48 1v12h7v-12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc29",
    d: "M-14 0c0-9 6-17 14-17S14-9 14 0 8 17 0 17-14 9-14 0z",
    transform: "translate(446 257)",
    stroke: "url(\"#e7xpoug7ckgc29-stroke\")",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc30",
    d: "M-14 0c0-9 6-17 14-17S14-9 14 0 8 17 0 17-14 9-14 0z",
    transform: "translate(443 259)",
    stroke: "url(\"#e7xpoug7ckgc30-stroke\")",
    strokeWidth: 8.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc31",
    stroke: "url(\"#e7xpoug7ckgc31-stroke\")",
    strokeWidth: 9,
    d: "M428 259h-48v13h7v-13"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e7xpoug7ckgc32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc33",
    d: "M297 290v-16c-2-3-3-7-3-11 0-6 2-11 5-14l183-39v121z",
    fill: "none",
    stroke: "#FF00FC",
    strokeWidth: 1,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc34",
    d: "M400 227l-98 21c-5 1-8 7-8 15 0 4 1 8 3 11v16l102 26z",
    fill: "url(\"#e7xpoug7ckgc34-fill\")",
    stroke: "none",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc35",
    display: "none",
    fill: "url(\"#e7xpoug7ckgc35-fill\")",
    stroke: "none",
    strokeWidth: 1,
    opacity: 0,
    d: "M120 210l-77-16v30l77-14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc36",
    display: "none",
    fill: "url(\"#e7xpoug7ckgc36-fill\")",
    stroke: "none",
    strokeWidth: 1,
    opacity: 0,
    d: "M361 210l77-16v30l-77-14z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "e7xpoug7ckgc37",
    rx: 19.9,
    ry: 33.8,
    transform: "translate(302 268)",
    fill: "url(\"#e7xpoug7ckgc37-fill\")",
    stroke: "none",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "e7xpoug7ckgc38",
    r: 11.9,
    transform: "translate(302 261)",
    fill: "url(\"#e7xpoug7ckgc38-fill\")",
    stroke: "none",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "e7xpoug7ckgc39",
    transform: "translate(1 -136)",
    opacity: 0,
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc40",
    fill: "#24369F",
    stroke: "none",
    d: "M240 242l121-32v-15l-121 32v15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc41",
    fill: "url(\"#e7xpoug7ckgc41-fill\")",
    stroke: "none",
    d: "M240 227v15l-120-32v-15l120 32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc42",
    fill: "url(\"#e7xpoug7ckgc42-fill\")",
    stroke: "none",
    d: "M240 227l-120-32 120-33 121 33-121 32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc43",
    fill: "none",
    stroke: "url(\"#e7xpoug7ckgc43-stroke\")",
    strokeMiterlimit: 10,
    d: "M361 210l-121 32-120-32"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "e7xpoug7ckgc44",
    clipPath: "url(#e7xpoug7ckgc92)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e7xpoug7ckgc45",
    transform: "translate(-16 -11) scale(1.01187)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e7xpoug7ckgc46"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "e7xpoug7ckgc47",
    width: 107.9,
    height: 107.9,
    rx: 0,
    ry: 0,
    transform: "translate(325 167)",
    fill: "url(\"#e7xpoug7ckgc47-fill\")",
    stroke: "none",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc48",
    fill: "none",
    stroke: "#6C687D",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    d: "M379 178v85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc49",
    fill: "none",
    stroke: "#6C687D",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    d: "M336 221h85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc50",
    fill: "none",
    stroke: "#6C687D",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    d: "M336 263l85-85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc51",
    d: "M336 263c67-12 13-73 85-85",
    fill: "none",
    stroke: "url(\"#e7xpoug7ckgc51-stroke\")",
    strokeWidth: 2.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    id: "e7xpoug7ckgc52",
    width: 84.8,
    height: 84.8,
    rx: 0,
    ry: 0,
    transform: "translate(336 178)",
    fill: "none",
    stroke: "#6C687D",
    strokeWidth: 2.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc53",
    fill: "none",
    stroke: "#6C687D",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    d: "M349 190h1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc54",
    fill: "none",
    stroke: "#6C687D",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeDasharray: "1 1",
    d: "M351 190l69-11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc55",
    fill: "none",
    stroke: "#6C687D",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    d: "M421 179v-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc56",
    fill: "none",
    stroke: "#6C687D",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    d: "M336 263h1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc57",
    fill: "none",
    stroke: "#6C687D",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeDasharray: "1 1",
    d: "M338 263l64-12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc58",
    fill: "none",
    stroke: "#6C687D",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    d: "M402 251h1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "e7xpoug7ckgc59",
    r: 2.9,
    transform: "translate(349 190)",
    fill: "#6C96F0",
    stroke: "#6C687D",
    strokeWidth: 1.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    id: "e7xpoug7ckgc60",
    r: 2.9,
    transform: "translate(403 251)",
    fill: "#6C96F0",
    stroke: "#6C687D",
    strokeWidth: 1.1,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("circle", {
    id: "e7xpoug7ckgc61",
    r: 21.7,
    transform: "translate(365 123)",
    opacity: 0.8,
    fill: "url(\"#e7xpoug7ckgc61-fill\")",
    stroke: "none",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "e7xpoug7ckgc62",
    r: 7.3,
    transform: "translate(365 274)",
    fill: "#0021F1",
    stroke: "none",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "e7xpoug7ckgc63",
    r: 3.2,
    transform: "translate(119 249)",
    fill: "#FFD31A",
    stroke: "none",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "e7xpoug7ckgc64",
    r: 7.3,
    transform: "translate(133 80)",
    fill: "#A090FF",
    stroke: "none",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "e7xpoug7ckgc65",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    id: "e7xpoug7ckgc66",
    r: 107.2,
    transform: "translate(241 182)",
    opacity: 0.5,
    filter: "url(#e7xpoug7ckgc66-filter)",
    fill: "#231D45"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "e7xpoug7ckgc67",
    r: 107.2,
    transform: "translate(237 179)",
    fill: "url(\"#e7xpoug7ckgc67-fill\")"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "e7xpoug7ckgc68",
    r: 107.2,
    transform: "translate(232 171)",
    fill: "url(\"#e7xpoug7ckgc68-fill\")"
  })), /*#__PURE__*/React.createElement("g", {
    id: "e7xpoug7ckgc69",
    transform: "translate(-1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc70",
    d: "M334 81c-17 0-31 13-31 31 0 20 17 26 17 44h29c0-18 16-24 16-44a31 31 0 00-31-31z",
    fill: "url(\"#e7xpoug7ckgc70-fill\")",
    stroke: "none",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc71",
    d: "M330 157l-2-12c0-10-1-21-3-23-1-1-3-2-3-5 1-3 4-3 8-2a5 5 0 019 0c4-1 7-1 7 2 1 3-1 4-2 5-2 2-3 13-4 23l-1 12",
    fill: "none",
    stroke: "#020917",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc72",
    d: "M349 156h-29c-2 0-4 1-4 3a4 4 0 004 4v4a7 7 0 007 8c1 2 4 3 7 3 4 0 7-1 7-3h1a7 7 0 007-8v-4a4 4 0 004-4c-1-2-2-3-4-3z",
    fill: "url(\"#e7xpoug7ckgc72-fill\")",
    stroke: "none",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "e7xpoug7ckgc73",
    r: 45.9,
    transform: "translate(335 112)",
    opacity: 0.9,
    fill: "url(\"#e7xpoug7ckgc73-fill\")",
    stroke: "none",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "e7xpoug7ckgc74",
    transform: "translate(-1 -1)",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc75",
    d: "M272 226l28 38a6 6 0 11-2 2l-29-38 17 76s12-1 20 6l14 11c8-2 22-13 26-20l-7-14c-4-10 0-23 0-23z",
    transform: "translate(0 8)",
    opacity: 0.5,
    filter: "url(#e7xpoug7ckgc75-filter)",
    fill: "#1E1A3D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc76",
    d: "M339 264s-3 13 0 22l5 12v2l-2 4c-1 2-2 4-9-5-7-8-4-24-4-24z",
    fill: "url(\"#e7xpoug7ckgc76-fill\")"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc77",
    d: "M286 304s13 0 21 5l10 8 3 1h4c1-1 4-2-2-10-6-9-22-11-22-11z",
    fill: "url(\"#e7xpoug7ckgc77-fill\")"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc78",
    d: "M272 226l28 38a6 6 0 11-2 2l-29-38 17 76s16-4 25 3l13 11c8-2 14-7 18-14l-7-15c-4-10 4-25 4-25z",
    fill: "url(\"#e7xpoug7ckgc78-fill\")"
  })), /*#__PURE__*/React.createElement("g", {
    id: "e7xpoug7ckgc79",
    transform: "translate(1)",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc80",
    d: "M257 211H112c-14 0-20-12-20-21l4-72c0-9 7-16 16-16l141-6c9 0 20 7 20 22v77c0 9-7 16-16 16z",
    transform: "translate(4 4)",
    opacity: 0.7,
    filter: "url(#e7xpoug7ckgc80-filter)",
    fill: "#231C44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc81",
    d: "M257 211H112c-14 0-20-12-20-21l4-72c0-9 7-16 16-16l141-6c9 0 20 7 20 22v77c0 9-7 16-16 16z",
    fill: "url(\"#e7xpoug7ckgc81-fill\")"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "e7xpoug7ckgc82",
    width: 177.2,
    height: 109.6,
    rx: 12,
    ry: 12,
    transform: "translate(92 96)",
    fill: "url(\"#e7xpoug7ckgc82-fill\")"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc83",
    d: "M138 144a15 15 0 016 1l1 2-6 2h-6a60 60 0 01-6 1 7 7 0 01-3-1l-1-2a3 3 0 012-2 12 12 0 014-1l5-1h3a10 10 0 001 1zm38 25a15 15 0 015 2c1 0 2 1 1 2l-5 1-6 1a59 59 0 01-7 0 7 7 0 01-3 0l-1-2a3 3 0 012-3 12 12 0 015-1h7a10 10 0 002 0zm55-8a11 11 0 01-6-2 9 9 0 01-4-5 9 9 0 010-5 10 10 0 014-5 10 10 0 015-2c4 0 6 1 8 3a10 10 0 012 6 25 25 0 01-2 11 16 16 0 01-7 8 18 18 0 01-4 2 12 12 0 01-5 0 8 8 0 01-1 0 2 2 0 01-2-2 2 2 0 011-1 8 8 0 012-1 14 14 0 011-1 12 12 0 008-6zm25-14a32 32 0 010 9 22 22 0 01-2 8 16 16 0 01-7 6 17 17 0 01-4 2 11 11 0 01-4 0 8 8 0 01-2 0 2 2 0 01-1-2 2 2 0 010-1 8 8 0 012-1 13 13 0 012-1 12 12 0 005-3 17 17 0 004-6 15 15 0 000-6v-3-3a9 9 0 010-1 4 4 0 010-2 3 3 0 011-1 6 6 0 012 0 7 7 0 011 0 2 2 0 012 0 5 5 0 011 2 24 24 0 010 3zm-39 2a11 11 0 00-4-5 12 12 0 00-7-2 12 12 0 00-10 5 12 12 0 00-1 3l-1 2a11 11 0 01-1 2 3 3 0 01-3 2 15 15 0 01-6-1 8 8 0 01-3-3 7 7 0 01-2-3v-1a12 12 0 010-2l-2-4a2 2 0 00-3 0 3 3 0 00-1 2 23 23 0 000 4 23 23 0 010 3 6 6 0 01-1 2 4 4 0 01-2 2 7 7 0 01-3 1 5 5 0 01-4-1 7 7 0 01-2-3 21 21 0 01-1-4v-2l-2-4a2 2 0 00-3 0 4 4 0 00-1 2l-1 2a8 8 0 01-1 3 13 13 0 01-6 5 40 40 0 01-11 2 53 53 0 01-10-1 24 24 0 01-8-2q-5-2-5-5t4-6q4-3 14-4l7-1v-1a21 21 0 00-5-1 38 38 0 00-8 0 35 35 0 00-8 2 19 19 0 00-7 4 11 11 0 00-3 7 10 10 0 002 7 19 19 0 007 5 31 31 0 005 2 40 40 0 0012 1 48 48 0 0013-2 20 20 0 0010-5 8 8 0 002 5 12 12 0 005 2 19 19 0 004 0h1a9 9 0 005-1 9 9 0 003-4 11 11 0 005 4 18 18 0 007 1h3a4 4 0 002 0 11 11 0 004-3 11 11 0 001 2 13 13 0 008 4 13 13 0 009-2q4-3 4-9a13 13 0 00-1-6zm-9 7v5h-4v-5a4 4 0 114 0z",
    opacity: 0.9,
    fill: "url(\"#e7xpoug7ckgc83-fill\")"
  })), /*#__PURE__*/React.createElement("g", {
    id: "e7xpoug7ckgc84",
    transform: "translate(1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc85",
    d: "M85 245a54 54 0 1196 49",
    fill: "none",
    stroke: "#5BB8FF",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    id: "e7xpoug7ckgc86",
    r: 5.8,
    transform: "translate(181 294)",
    fill: "#FFFFFF",
    stroke: "#5AB8FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc87",
    fill: "none",
    stroke: "#5BB8FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M110 197l96 49"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "e7xpoug7ckgc88",
    r: 5.8,
    transform: "translate(85 244)",
    fill: "#FFFFFF",
    stroke: "#5AB8FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    id: "e7xpoug7ckgc89",
    r: 2.9,
    transform: "translate(110 197)",
    fill: "url(\"#e7xpoug7ckgc89-fill\")",
    stroke: "none",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "e7xpoug7ckgc90",
    r: 2.9,
    transform: "translate(206 246)",
    fill: "url(\"#e7xpoug7ckgc90-fill\")",
    stroke: "none",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "e7xpoug7ckgc91",
    r: 5.8,
    transform: "translate(158 221)",
    fill: "#FCFEFF",
    stroke: "#5BB8FF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "e7xpoug7ckgc92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e7xpoug7ckgc93",
    d: "M4 356l234 3 240-2 4-147V1H-1v209l5 146z",
    fill: "none",
    stroke: "#FF00FC",
    strokeWidth: 1,
    strokeMiterlimit: 10
  }))))), _script || (_script = /*#__PURE__*/React.createElement("script", null, "!function(t,n){&quot;object&quot;==typeof exports&amp;&amp;&quot;undefined&quot;!=typeof module?module.exports=n():&quot;function&quot;==typeof define&amp;&amp;define.amd?define(n):(t=&quot;undefined&quot;!=typeof globalThis?globalThis:t||self).__SVGATOR_PLAYER__=n()}(this,(function(){&quot;use strict&quot;;function t(n){return(t=&quot;function&quot;==typeof Symbol&amp;&amp;&quot;symbol&quot;==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&amp;&amp;&quot;function&quot;==typeof Symbol&amp;&amp;t.constructor===Symbol&amp;&amp;t!==Symbol.prototype?&quot;symbol&quot;:typeof t})(n)}function n(t,n){if(!(t instanceof n))throw new TypeError(&quot;Cannot call a class as a function&quot;)}function e(t,n){for(var e=0;e&lt;n.length;e++){var r=n[e];r.enumerable=r.enumerable||!1,r.configurable=!0,&quot;value&quot;in r&amp;&amp;(r.writable=!0),Object.defineProperty(t,r.key,r)}}function r(t,n,r){return n&amp;&amp;e(t.prototype,n),r&amp;&amp;e(t,r),t}function i(t){return(i=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function u(t,n){return(u=Object.setPrototypeOf||function(t,n){return t.__proto__=n,t})(t,n)}function o(t,n){return!n||&quot;object&quot;!=typeof n&amp;&amp;&quot;function&quot;!=typeof n?function(t){if(void 0===t)throw new ReferenceError(&quot;this hasn&apos;t been initialised - super() hasn&apos;t been called&quot;);return t}(t):n}function a(t){var n=function(){if(&quot;undefined&quot;==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if(&quot;function&quot;==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}();return function(){var e,r=i(t);if(n){var u=i(this).constructor;e=Reflect.construct(r,arguments,u)}else e=r.apply(this,arguments);return o(this,e)}}function l(t,n,e){return(l=&quot;undefined&quot;!=typeof Reflect&amp;&amp;Reflect.get?Reflect.get:function(t,n,e){var r=function(t,n){for(;!Object.prototype.hasOwnProperty.call(t,n)&amp;&amp;null!==(t=i(t)););return t}(t,n);if(r){var u=Object.getOwnPropertyDescriptor(r,n);return u.get?u.get.call(e):u.value}})(t,n,e||t)}var s=Math.abs;function f(t){return t}function c(t,n,e){var r=1-e;return 3*e*r*(t*r+n*e)+e*e*e}function h(){var t=arguments.length&gt;0&amp;&amp;void 0!==arguments[0]?arguments[0]:0,n=arguments.length&gt;1&amp;&amp;void 0!==arguments[1]?arguments[1]:0,e=arguments.length&gt;2&amp;&amp;void 0!==arguments[2]?arguments[2]:1,r=arguments.length&gt;3&amp;&amp;void 0!==arguments[3]?arguments[3]:1;return t&lt;0||t&gt;1||e&lt;0||e&gt;1?null:s(t-n)&lt;=1e-5&amp;&amp;s(e-r)&lt;=1e-5?f:function(i){if(i&lt;=0)return t&gt;0?i*n/t:0===n&amp;&amp;e&gt;0?i*r/e:0;if(i&gt;=1)return e&lt;1?1+(i-1)*(r-1)/(e-1):1===e&amp;&amp;t&lt;1?1+(i-1)*(n-1)/(t-1):1;for(var u,o=0,a=1;o&lt;a;){var l=c(t,e,u=(o+a)/2);if(s(i-l)&lt;1e-5)break;l&lt;i?o=u:a=u}return c(n,r,u)}}function v(){return 1}function d(t){return 1===t?1:0}function y(){var t=arguments.length&gt;0&amp;&amp;void 0!==arguments[0]?arguments[0]:1,n=arguments.length&gt;1&amp;&amp;void 0!==arguments[1]?arguments[1]:0;if(1===t){if(0===n)return d;if(1===n)return v}var e=1/t;return function(t){return t&gt;=1?1:(t+=n*e)-t%e}}function g(t){var n=arguments.length&gt;1&amp;&amp;void 0!==arguments[1]?arguments[1]:2;if(Number.isInteger(t))return t;var e=Math.pow(10,n);return Math.round(t*e)/e}var p=Math.PI/180;function m(t,n,e){return t&gt;=.5?e:n}function b(t,n,e){return 0===t||n===e?n:t*(e-n)+n}function w(t,n,e){var r=b(t,n,e);return r&lt;=0?0:r}function x(t,n,e){return 0===t?n:1===t?e:{x:b(t,n.x,e.x),y:b(t,n.y,e.y)}}function A(t,n,e){return 0===t?n:1===t?e:{x:w(t,n.x,e.x),y:w(t,n.y,e.y)}}function k(t,n,e){var r=function(t,n,e){return Math.round(b(t,n,e))}(t,n,e);return r&lt;=0?0:r&gt;=255?255:r}function _(t,n,e){return 0===t?n:1===t?e:{r:k(t,n.r,e.r),g:k(t,n.g,e.g),b:k(t,n.b,e.b),a:b(t,null==n.a?1:n.a,null==e.a?1:e.a)}}function S(t,n,e){if(0===t)return n;if(1===t)return e;var r=n.length;if(r!==e.length)return m(t,n,e);for(var i=[],u=0;u&lt;r;u++)i.push(_(t,n[u],e[u]));return i}function M(t,n,e){var r=n.length;if(r!==e.length)return m(t,n,e);for(var i=new Array(r),u=0;u&lt;r;u++)i[u]=b(t,n[u],e[u]);return i}function O(t,n){for(var e=[],r=0;r&lt;t;r++)e.push(n);return e}function E(t,n){if(--n&lt;=0)return t;var e=(t=Object.assign([],t)).length;do{for(var r=0;r&lt;e;r++)t.push(t[r])}while(--n&gt;0);return t}var B,I=function(){function t(e){n(this,t),this.list=e,this.length=e.length}return r(t,[{key:&quot;setAttribute&quot;,value:function(t,n){for(var e=this.list,r=0;r&lt;this.length;r++)e[r].setAttribute(t,n)}},{key:&quot;removeAttribute&quot;,value:function(t){for(var n=this.list,e=0;e&lt;this.length;e++)n[e].removeAttribute(t)}},{key:&quot;style&quot;,value:function(t,n){for(var e=this.list,r=0;r&lt;this.length;r++)e[r].style[t]=n}}]),t}(),j=/-./g,P=function(t,n){return n.toUpperCase()};function T(t){return&quot;function&quot;==typeof t?t:m}function F(t){return t?&quot;function&quot;==typeof t?t:Array.isArray(t)?function(t){var n=arguments.length&gt;1&amp;&amp;void 0!==arguments[1]?arguments[1]:f;if(!Array.isArray(t))return n;switch(t.length){case 1:return y(t[0])||n;case 2:return y(t[0],t[1])||n;case 4:return h(t[0],t[1],t[2],t[3])||n}return n}(t,null):function(t,n){var e=arguments.length&gt;2&amp;&amp;void 0!==arguments[2]?arguments[2]:f;switch(t){case&quot;linear&quot;:return f;case&quot;steps&quot;:return y(n.steps||1,n.jump||0)||e;case&quot;bezier&quot;:case&quot;cubic-bezier&quot;:return h(n.x1||0,n.y1||0,n.x2||0,n.y2||0)||e}return e}(t.type,t.value,null):null}function R(t,n,e){var r=arguments.length&gt;3&amp;&amp;void 0!==arguments[3]&amp;&amp;arguments[3],i=n.length-1;if(t&lt;=n[0].t)return r?[0,0,n[0].v]:n[0].v;if(t&gt;=n[i].t)return r?[i,1,n[i].v]:n[i].v;var u,o=n[0],a=null;for(u=1;u&lt;=i;u++){if(!(t&gt;n[u].t)){a=n[u];break}o=n[u]}return null==a?r?[i,1,n[i].v]:n[i].v:o.t===a.t?r?[u,1,a.v]:a.v:(t=(t-o.t)/(a.t-o.t),o.e&amp;&amp;(t=o.e(t)),r?[u,t,e(t,o.v,a.v)]:e(t,o.v,a.v))}function C(t,n){var e=arguments.length&gt;2&amp;&amp;void 0!==arguments[2]?arguments[2]:null;return t&amp;&amp;t.length?&quot;function&quot;!=typeof n?null:(&quot;function&quot;!=typeof e&amp;&amp;(e=null),function(r){var i=R(r,t,n);return null!=i&amp;&amp;e&amp;&amp;(i=e(i)),i}):null}function N(t,n){return t.t-n.t}function q(n,e,r,i,u){var o,a=&quot;@&quot;===r[0],l=&quot;#&quot;===r[0],s=B[r],f=m;switch(a?(o=r.substr(1),r=o.replace(j,P)):l&amp;&amp;(r=r.substr(1)),t(s)){case&quot;function&quot;:if(f=s(i,u,R,F,r,a,e,n),l)return f;break;case&quot;string&quot;:f=C(i,T(s));break;case&quot;object&quot;:if((f=C(i,T(s.i),s.f))&amp;&amp;&quot;function&quot;==typeof s.u)return s.u(e,f,r,a,n)}return f?function(t,n,e){var r=arguments.length&gt;3&amp;&amp;void 0!==arguments[3]&amp;&amp;arguments[3];if(r)return t instanceof I?function(r){return t.style(n,e(r))}:function(r){return t.style[n]=e(r)};if(Array.isArray(n)){var i=n.length;return function(r){var u=e(r);if(null==u)for(var o=0;o&lt;i;o++)t[o].removeAttribute(n);else for(var a=0;a&lt;i;a++)t[a].setAttribute(n,u)}}return function(r){var i=e(r);null==i?t.removeAttribute(n):t.setAttribute(n,i)}}(e,r,f,a):null}function V(n,e,r,i){if(!i||&quot;object&quot;!==t(i))return null;var u=null,o=null;return Array.isArray(i)?o=function(t){if(!t||!t.length)return null;for(var n=0;n&lt;t.length;n++)t[n].e&amp;&amp;(t[n].e=F(t[n].e));return t.sort(N)}(i):(o=i.keys,u=i.data||null),o?q(n,e,r,o,u):null}function L(t,n,e){if(!e)return null;var r=[];for(var i in e)if(e.hasOwnProperty(i)){var u=V(t,n,i,e[i]);u&amp;&amp;r.push(u)}return r.length?r:null}function z(t,n){if(!n.duration||n.duration&lt;0)return null;var e=function(t,n){if(!n)return null;var e=[];if(Array.isArray(n))for(var r=n.length,i=0;i&lt;r;i++){var u=n[i];if(2===u.length){var o=null;if(&quot;string&quot;==typeof u[0])o=t.getElementById(u[0]);else if(Array.isArray(u[0])){o=[];for(var a=0;a&lt;u[0].length;a++)if(&quot;string&quot;==typeof u[0][a]){var l=t.getElementById(u[0][a]);l&amp;&amp;o.push(l)}o=o.length?1===o.length?o[0]:new I(o):null}if(o){var s=L(t,o,u[1]);s&amp;&amp;(e=e.concat(s))}}}else for(var f in n)if(n.hasOwnProperty(f)){var c=t.getElementById(f);if(c){var h=L(t,c,n[f]);h&amp;&amp;(e=e.concat(h))}}return e.length?e:null}(t,n.elements);return e?function(t,n){var e=arguments.length&gt;2&amp;&amp;void 0!==arguments[2]?arguments[2]:1/0,r=arguments.length&gt;3&amp;&amp;void 0!==arguments[3]?arguments[3]:1,i=arguments.length&gt;4&amp;&amp;void 0!==arguments[4]&amp;&amp;arguments[4],u=arguments.length&gt;5&amp;&amp;void 0!==arguments[5]?arguments[5]:1,o=t.length,a=r&gt;0?n:0;i&amp;&amp;e%2==0&amp;&amp;(a=n-a);var l=null;return function(s,f){var c=s%n,h=1+(s-c)/n;f*=r,i&amp;&amp;h%2==0&amp;&amp;(f=-f);var v=!1;if(h&gt;e)c=a,v=!0,-1===u&amp;&amp;(c=r&gt;0?0:n);else if(f&lt;0&amp;&amp;(c=n-c),c===l)return!1;l=c;for(var d=0;d&lt;o;d++)t[d](c);return v}}(e,n.duration,n.iterations||1/0,n.direction||1,!!n.alternate,n.fill||1):null}var D=function(){function t(e,r){var i=arguments.length&gt;2&amp;&amp;void 0!==arguments[2]?arguments[2]:{};n(this,t),this._id=0,this._running=!1,this._rollingBack=!1,this._animations=e,this.duration=r.duration,this.alternate=r.alternate,this.fill=r.fill,this.iterations=r.iterations,this.direction=i.direction||1,this.speed=i.speed||1,this.fps=i.fps||100,this.offset=i.offset||0,this.rollbackStartOffset=0}return r(t,[{key:&quot;_rollback&quot;,value:function(){var t=this,n=1/0,e=null;this.rollbackStartOffset=this.offset,this._rollingBack||(this._rollingBack=!0,this._running=!0);this._id=window.requestAnimationFrame((function r(i){if(t._rollingBack){null==e&amp;&amp;(e=i);var u=i-e,o=t.rollbackStartOffset-u,a=Math.round(o*t.speed);if(a&gt;t.duration&amp;&amp;n!=1/0){var l=!!t.alternate&amp;&amp;a/t.duration%2&gt;1,s=a%t.duration;a=(s+=l?t.duration:0)||t.duration}var f=t.fps?1e3/t.fps:0,c=Math.max(0,a);if(c&lt;n-f){t.offset=c,n=c;for(var h=t._animations,v=h.length,d=0;d&lt;v;d++)h[d](c,t.direction)}var y=!1;if(t.iterations&gt;0&amp;&amp;-1===t.fill){var g=t.iterations*t.duration,p=g==a;a=p?0:a,t.offset=p?0:t.offset,y=a&gt;g}a&gt;0&amp;&amp;t.offset&gt;=a&amp;&amp;!y?t._id=window.requestAnimationFrame(r):t.stop()}}))}},{key:&quot;_start&quot;,value:function(){var t=this,n=arguments.length&gt;0&amp;&amp;void 0!==arguments[0]?arguments[0]:0,e=-1/0,r=null,i={},u=function u(o){t._running=!0,null==r&amp;&amp;(r=o);var a=Math.round((o-r+n)*t.speed),l=t.fps?1e3/t.fps:0;if(a&gt;e+l&amp;&amp;!t._rollingBack){t.offset=a,e=a;for(var s=t._animations,f=s.length,c=0,h=0;h&lt;f;h++)i[h]?c++:(i[h]=s[h](a,t.direction),i[h]&amp;&amp;c++);if(c===f)return void t._stop()}t._id=window.requestAnimationFrame(u)};this._id=window.requestAnimationFrame(u)}},{key:&quot;_stop&quot;,value:function(){this._id&amp;&amp;window.cancelAnimationFrame(this._id),this._running=!1,this._rollingBack=!1}},{key:&quot;play&quot;,value:function(){!this._rollingBack&amp;&amp;this._running||(this._rollingBack=!1,this.rollbackStartOffset&gt;this.duration&amp;&amp;(this.offset=this.rollbackStartOffset-(this.rollbackStartOffset-this.offset)%this.duration,this.rollbackStartOffset=0),this._start(this.offset))}},{key:&quot;stop&quot;,value:function(){this._stop(),this.offset=0,this.rollbackStartOffset=0;var t=this.direction,n=this._animations;window.requestAnimationFrame((function(){for(var e=0;e&lt;n.length;e++)n[e](0,t)}))}},{key:&quot;reachedToEnd&quot;,value:function(){return this.iterations&gt;0&amp;&amp;this.offset&gt;=this.iterations*this.duration}},{key:&quot;restart&quot;,value:function(){this._stop(),this.offset=0,this._start()}},{key:&quot;pause&quot;,value:function(){this._stop()}},{key:&quot;reverse&quot;,value:function(){this.direction=-this.direction}}],[{key:&quot;build&quot;,value:function(n,e){return(n=function(t,n){if(B=n,!t||!t.root||!Array.isArray(t.animations))return null;for(var e=document.getElementsByTagName(&quot;svg&quot;),r=!1,i=0;i&lt;e.length;i++)if(e[i].id===t.root&amp;&amp;!e[i].svgatorAnimation){(r=e[i]).svgatorAnimation=!0;break}if(!r)return null;var u=t.animations.map((function(t){return z(r,t)})).filter((function(t){return!!t}));return u.length?{element:r,animations:u,animationSettings:t.animationSettings,options:t.options||void 0}:null}(n,e))?{el:n.element,options:n.options||{},player:new t(n.animations,n.animationSettings,n.options)}:null}}]),t}();!function(){for(var t=0,n=[&quot;ms&quot;,&quot;moz&quot;,&quot;webkit&quot;,&quot;o&quot;],e=0;e&lt;n.length&amp;&amp;!window.requestAnimationFrame;++e)window.requestAnimationFrame=window[n[e]+&quot;RequestAnimationFrame&quot;],window.cancelAnimationFrame=window[n[e]+&quot;CancelAnimationFrame&quot;]||window[n[e]+&quot;CancelRequestAnimationFrame&quot;];window.requestAnimationFrame||(window.requestAnimationFrame=function(n){var e=Date.now(),r=Math.max(0,16-(e-t)),i=window.setTimeout((function(){n(e+r)}),r);return t=e+r,i},window.cancelAnimationFrame=window.clearTimeout)}();var U=function(t,n){var e=!1,r=null;return function(i){e&amp;&amp;clearTimeout(e),e=setTimeout((function(){return function(){for(var i=0,u=window.innerHeight,o=0,a=window.innerWidth,l=t.parentNode;l instanceof Element;){var s=window.getComputedStyle(l);if(&quot;visible&quot;!==s.overflowY||&quot;visible&quot;!==s.overflowX){var f=l.getBoundingClientRect();&quot;visible&quot;!==s.overflowY&amp;&amp;(i=Math.max(i,f.top),u=Math.min(u,f.bottom)),&quot;visible&quot;!==s.overflowX&amp;&amp;(o=Math.max(o,f.left),a=Math.min(a,f.right))}if(l===l.parentNode)break;l=l.parentNode}e=!1;var c=t.getBoundingClientRect(),h=Math.min(c.height,Math.max(0,i-c.top)),v=Math.min(c.height,Math.max(0,c.bottom-u)),d=Math.min(c.width,Math.max(0,o-c.left)),y=Math.min(c.width,Math.max(0,c.right-a)),g=(c.height-h-v)/c.height,p=(c.width-d-y)/c.width,m=Math.round(g*p*100);null!==r&amp;&amp;r===m||(r=m,n(m))}()}),100)}},W=function(){function t(e,r,i){n(this,t),r=Math.max(1,r||1),r=Math.min(r,100),this.el=e,this.onTresholdChange=i&amp;&amp;i.call?i:function(){},this.tresholdPercent=r||1,this.currentVisibility=null,this.visibilityCalculator=U(e,this.onVisibilityUpdate.bind(this)),this.bindScrollWatchers(),this.visibilityCalculator()}return r(t,[{key:&quot;bindScrollWatchers&quot;,value:function(){for(var t=this.el.parentNode;t&amp;&amp;(t.addEventListener(&quot;scroll&quot;,this.visibilityCalculator),t!==t.parentNode&amp;&amp;t!==document);)t=t.parentNode}},{key:&quot;onVisibilityUpdate&quot;,value:function(t){var n=this.currentVisibility&gt;=this.tresholdPercent,e=t&gt;=this.tresholdPercent;if(null===this.currentVisibility||n!==e)return this.currentVisibility=t,void this.onTresholdChange(e);this.currentVisibility=t}}]),t}(),Y=/\\.0+$/g;function G(t){return Number.isInteger(t)?t+&quot;&quot;:t.toFixed(6).replace(Y,&quot;&quot;)}function H(t){var n=arguments.length&gt;1&amp;&amp;void 0!==arguments[1]?arguments[1]:&quot; &quot;;return t&amp;&amp;t.length?t.map(G).join(n):&quot;&quot;}function Q(t){return G(t.x)+&quot;,&quot;+G(t.y)}function X(t){return t?null==t.a||t.a&gt;=1?&quot;rgb(&quot;+t.r+&quot;,&quot;+t.g+&quot;,&quot;+t.b+&quot;)&quot;:&quot;rgba(&quot;+t.r+&quot;,&quot;+t.g+&quot;,&quot;+t.b+&quot;,&quot;+t.a+&quot;)&quot;:&quot;transparent&quot;}var $={f:null,i:A,u:function(t,n){return function(e){var r=n(e);t.setAttribute(&quot;rx&quot;,G(r.x)),t.setAttribute(&quot;ry&quot;,G(r.y))}}},Z={f:null,i:function(t,n,e){return 0===t?n:1===t?e:{width:w(t,n.width,e.width),height:w(t,n.height,e.height)}},u:function(t,n){return function(e){var r=n(e);t.setAttribute(&quot;width&quot;,G(r.width)),t.setAttribute(&quot;height&quot;,G(r.height))}}},J=Math.sin,K=Math.cos,tt=Math.acos,nt=Math.asin,et=Math.tan,rt=Math.atan2,it=Math.PI/180,ut=180/Math.PI,ot=Math.sqrt,at=function(){function t(){var e=arguments.length&gt;0&amp;&amp;void 0!==arguments[0]?arguments[0]:1,r=arguments.length&gt;1&amp;&amp;void 0!==arguments[1]?arguments[1]:0,i=arguments.length&gt;2&amp;&amp;void 0!==arguments[2]?arguments[2]:0,u=arguments.length&gt;3&amp;&amp;void 0!==arguments[3]?arguments[3]:1,o=arguments.length&gt;4&amp;&amp;void 0!==arguments[4]?arguments[4]:0,a=arguments.length&gt;5&amp;&amp;void 0!==arguments[5]?arguments[5]:0;n(this,t),this.m=[e,r,i,u,o,a],this.i=null,this.w=null,this.s=null}return r(t,[{key:&quot;determinant&quot;,get:function(){var t=this.m;return t[0]*t[3]-t[1]*t[2]}},{key:&quot;isIdentity&quot;,get:function(){if(null===this.i){var t=this.m;this.i=1===t[0]&amp;&amp;0===t[1]&amp;&amp;0===t[2]&amp;&amp;1===t[3]&amp;&amp;0===t[4]&amp;&amp;0===t[5]}return this.i}},{key:&quot;point&quot;,value:function(t,n){var e=this.m;return{x:e[0]*t+e[2]*n+e[4],y:e[1]*t+e[3]*n+e[5]}}},{key:&quot;translateSelf&quot;,value:function(){var t=arguments.length&gt;0&amp;&amp;void 0!==arguments[0]?arguments[0]:0,n=arguments.length&gt;1&amp;&amp;void 0!==arguments[1]?arguments[1]:0;if(!t&amp;&amp;!n)return this;var e=this.m;return e[4]+=e[0]*t+e[2]*n,e[5]+=e[1]*t+e[3]*n,this.w=this.s=this.i=null,this}},{key:&quot;rotateSelf&quot;,value:function(){var t=arguments.length&gt;0&amp;&amp;void 0!==arguments[0]?arguments[0]:0;if(t%=360){var n=J(t*=it),e=K(t),r=this.m,i=r[0],u=r[1];r[0]=i*e+r[2]*n,r[1]=u*e+r[3]*n,r[2]=r[2]*e-i*n,r[3]=r[3]*e-u*n,this.w=this.s=this.i=null}return this}},{key:&quot;scaleSelf&quot;,value:function(){var t=arguments.length&gt;0&amp;&amp;void 0!==arguments[0]?arguments[0]:1,n=arguments.length&gt;1&amp;&amp;void 0!==arguments[1]?arguments[1]:1;if(1!==t||1!==n){var e=this.m;e[0]*=t,e[1]*=t,e[2]*=n,e[3]*=n,this.w=this.s=this.i=null}return this}},{key:&quot;skewSelf&quot;,value:function(t,n){if(n%=360,(t%=360)||n){var e=this.m,r=e[0],i=e[1],u=e[2],o=e[3];t&amp;&amp;(t=et(t*it),e[2]+=r*t,e[3]+=i*t),n&amp;&amp;(n=et(n*it),e[0]+=u*n,e[1]+=o*n),this.w=this.s=this.i=null}return this}},{key:&quot;resetSelf&quot;,value:function(){var t=arguments.length&gt;0&amp;&amp;void 0!==arguments[0]?arguments[0]:1,n=arguments.length&gt;1&amp;&amp;void 0!==arguments[1]?arguments[1]:0,e=arguments.length&gt;2&amp;&amp;void 0!==arguments[2]?arguments[2]:0,r=arguments.length&gt;3&amp;&amp;void 0!==arguments[3]?arguments[3]:1,i=arguments.length&gt;4&amp;&amp;void 0!==arguments[4]?arguments[4]:0,u=arguments.length&gt;5&amp;&amp;void 0!==arguments[5]?arguments[5]:0,o=this.m;return o[0]=t,o[1]=n,o[2]=e,o[3]=r,o[4]=i,o[5]=u,this.w=this.s=this.i=null,this}},{key:&quot;recomposeSelf&quot;,value:function(){var t=arguments.length&gt;0&amp;&amp;void 0!==arguments[0]?arguments[0]:null,n=arguments.length&gt;1&amp;&amp;void 0!==arguments[1]?arguments[1]:null,e=arguments.length&gt;2&amp;&amp;void 0!==arguments[2]?arguments[2]:null,r=arguments.length&gt;3&amp;&amp;void 0!==arguments[3]?arguments[3]:null,i=arguments.length&gt;4&amp;&amp;void 0!==arguments[4]?arguments[4]:null;return this.isIdentity||this.resetSelf(),t&amp;&amp;(t.x||t.y)&amp;&amp;this.translateSelf(t.x,t.y),n&amp;&amp;this.rotateSelf(n),e&amp;&amp;(e.x&amp;&amp;this.skewSelf(e.x,0),e.y&amp;&amp;this.skewSelf(0,e.y)),!r||1===r.x&amp;&amp;1===r.y||this.scaleSelf(r.x,r.y),i&amp;&amp;(i.x||i.y)&amp;&amp;this.translateSelf(i.x,i.y),this}},{key:&quot;decompose&quot;,value:function(){var t=arguments.length&gt;0&amp;&amp;void 0!==arguments[0]?arguments[0]:0,n=arguments.length&gt;1&amp;&amp;void 0!==arguments[1]?arguments[1]:0,e=this.m,r=e[0]*e[0]+e[1]*e[1],i=[[e[0],e[1]],[e[2],e[3]]],u=ot(r);if(0===u)return{origin:{x:e[4],y:e[5]},translate:{x:t,y:n},scale:{x:0,y:0},skew:{x:0,y:0},rotate:0};i[0][0]/=u,i[0][1]/=u;var o=e[0]*e[3]-e[1]*e[2]&lt;0;o&amp;&amp;(u=-u);var a=i[0][0]*i[1][0]+i[0][1]*i[1][1];i[1][0]-=i[0][0]*a,i[1][1]-=i[0][1]*a;var l=ot(i[1][0]*i[1][0]+i[1][1]*i[1][1]);if(0===l)return{origin:{x:e[4],y:e[5]},translate:{x:t,y:n},scale:{x:u,y:0},skew:{x:0,y:0},rotate:0};i[1][0]/=l,i[1][1]/=l,a/=l;var s=0;return i[1][1]&lt;0?(s=tt(i[1][1])*ut,i[0][1]&lt;0&amp;&amp;(s=360-s)):s=nt(i[0][1])*ut,o&amp;&amp;(s=-s),a=rt(a,ot(i[0][0]*i[0][0]+i[0][1]*i[0][1]))*ut,o&amp;&amp;(a=-a),{origin:{x:e[4],y:e[5]},translate:{x:t,y:n},scale:{x:u,y:l},skew:{x:a,y:0},rotate:s}}},{key:&quot;toString&quot;,value:function(){return null===this.s&amp;&amp;(this.s=&quot;matrix(&quot;+this.m.map(st).join(&quot; &quot;)+&quot;)&quot;),this.s}}]),t}(),lt=/\\.0+$/;function st(t){return Number.isInteger(t)?t:t.toFixed(14).replace(lt,&quot;&quot;)}function ft(t,n,e){return t+(n-t)*e}function ct(t,n,e){var r=arguments.length&gt;3&amp;&amp;void 0!==arguments[3]&amp;&amp;arguments[3],i={x:ft(t.x,n.x,e),y:ft(t.y,n.y,e)};return r&amp;&amp;(i.a=ht(t,n)),i}function ht(t,n){return Math.atan2(n.y-t.y,n.x-t.x)}Object.freeze({M:2,L:2,Z:0,H:1,V:1,C:6,Q:4,T:2,S:4,A:7});var vt={},dt=null;function yt(n){var e=function(){if(dt)return dt;if(&quot;object&quot;!==(&quot;undefined&quot;==typeof document?&quot;undefined&quot;:t(document)))return{};var n=document.createElementNS(&quot;http://www.w3.org/2000/svg&quot;,&quot;svg&quot;);return n.style.position=&quot;absolute&quot;,n.style.opacity=&quot;0.01&quot;,n.style.zIndex=&quot;-9999&quot;,n.style.left=&quot;-9999px&quot;,n.style.width=&quot;1px&quot;,n.style.height=&quot;1px&quot;,dt={svg:n}}().svg;if(!e)return function(t){return null};var r=document.createElementNS(e.namespaceURI,&quot;path&quot;);r.setAttributeNS(null,&quot;d&quot;,n),r.setAttributeNS(null,&quot;fill&quot;,&quot;none&quot;),r.setAttributeNS(null,&quot;stroke&quot;,&quot;none&quot;),e.appendChild(r);var i=r.getTotalLength();return function(t){var n=r.getPointAtLength(i*t);return{x:n.x,y:n.y}}}function gt(t){return vt[t]?vt[t]:vt[t]=yt(t)}function pt(t,n,e,r){if(!t||!r)return!1;var i=[&quot;M&quot;,t.x,t.y];if(n&amp;&amp;e&amp;&amp;(i.push(&quot;C&quot;),i.push(n.x),i.push(n.y),i.push(e.x),i.push(e.y)),n?!e:e){var u=n||e;i.push(&quot;Q&quot;),i.push(u.x),i.push(u.y)}return n||e||i.push(&quot;L&quot;),i.push(r.x),i.push(r.y),i.join(&quot; &quot;)}function mt(t,n,e,r){var i=arguments.length&gt;4&amp;&amp;void 0!==arguments[4]?arguments[4]:1,u=pt(t,n,e,r),o=gt(u);try{return o(i)}catch(t){return null}}function bt(t,n,e,r){var i=1-r;return i*i*t+2*i*r*n+r*r*e}function wt(t,n,e,r){return 2*(1-r)*(n-t)+2*r*(e-n)}function xt(t,n,e,r){var i=arguments.length&gt;4&amp;&amp;void 0!==arguments[4]&amp;&amp;arguments[4],u=mt(t,n,null,e,r);return u||(u={x:bt(t.x,n.x,e.x,r),y:bt(t.y,n.y,e.y,r)}),i&amp;&amp;(u.a=At(t,n,e,r)),u}function At(t,n,e,r){return Math.atan2(wt(t.y,n.y,e.y,r),wt(t.x,n.x,e.x,r))}function kt(t,n,e,r,i){var u=i*i;return i*u*(r-t+3*(n-e))+3*u*(t+e-2*n)+3*i*(n-t)+t}function _t(t,n,e,r,i){var u=1-i;return 3*(u*u*(n-t)+2*u*i*(e-n)+i*i*(r-e))}function St(t,n,e,r,i){var u=arguments.length&gt;5&amp;&amp;void 0!==arguments[5]&amp;&amp;arguments[5],o=mt(t,n,e,r,i);return o||(o={x:kt(t.x,n.x,e.x,r.x,i),y:kt(t.y,n.y,e.y,r.y,i)}),u&amp;&amp;(o.a=Mt(t,n,e,r,i)),o}function Mt(t,n,e,r,i){return Math.atan2(_t(t.y,n.y,e.y,r.y,i),_t(t.x,n.x,e.x,r.x,i))}function Ot(t,n,e){var r=arguments.length&gt;3&amp;&amp;void 0!==arguments[3]&amp;&amp;arguments[3];if(Bt(n)){if(It(e))return xt(n,e.start,e,t,r)}else if(Bt(e)){if(n.end)return xt(n,n.end,e,t,r)}else{if(n.end)return e.start?St(n,n.end,e.start,e,t,r):xt(n,n.end,e,t,r);if(e.start)return xt(n,e.start,e,t,r)}return ct(n,e,t,r)}function Et(t,n,e){var r=Ot(t,n,e,!0);return r.a=function(t){var n=arguments.length&gt;1&amp;&amp;void 0!==arguments[1]&amp;&amp;arguments[1];return n?t+Math.PI:t}(r.a)/p,r}function Bt(t){return!t.type||&quot;corner&quot;===t.type}function It(t){return null!=t.start&amp;&amp;!Bt(t)}var jt=new at;var Pt={f:function(t){return t?t.join(&quot; &quot;):&quot;&quot;},i:function(n,e,r){if(0===n)return e;if(1===n)return r;var i=e.length;if(i!==r.length)return m(n,e,r);for(var u,o=new Array(i),a=0;a&lt;i;a++){if((u=t(e[a]))!==t(r[a]))return m(n,e,r);if(&quot;number&quot;===u)o[a]=b(n,e[a],r[a]);else{if(e[a]!==r[a])return m(n,e,r);o[a]=e[a]}}return o}},Tt={f:null,i:M,u:function(t,n){return function(e){var r=n(e);t.setAttribute(&quot;x1&quot;,G(r[0])),t.setAttribute(&quot;y1&quot;,G(r[1])),t.setAttribute(&quot;x2&quot;,G(r[2])),t.setAttribute(&quot;y2&quot;,G(r[3]))}}},Ft={f:G,i:b},Rt={f:G,i:function(t,n,e){var r=b(t,n,e);return r&lt;=0?0:r&gt;=1?1:r}},Ct={f:function(t){var n=arguments.length&gt;1&amp;&amp;void 0!==arguments[1]?arguments[1]:&quot; &quot;;return t&amp;&amp;t.length&gt;0&amp;&amp;(t=t.map((function(t){return Math.floor(1e4*t)/1e4}))),H(t,n)},i:function(t,n,e){var r,i,u,o=n.length,a=e.length;if(o!==a)if(0===o)n=O(o=a,0);else if(0===a)a=o,e=O(o,0);else{var l=(u=(r=o)*(i=a)/function(t,n){for(var e;n;)e=n,n=t%n,t=e;return t||1}(r,i))&lt;0?-u:u;n=E(n,Math.floor(l/o)),e=E(e,Math.floor(l/a)),o=a=l}for(var s=[],f=0;f&lt;o;f++)s.push(g(w(t,n[f],e[f]),6));return s}};function Nt(t,n,e,r,i,u,o,a){return n=function(t,n,e){for(var r,i,u,o=t.length-1,a={},l=0;l&lt;=o;l++)(r=t[l]).e&amp;&amp;(r.e=n(r.e)),r.v&amp;&amp;&quot;g&quot;===(i=r.v).t&amp;&amp;i.r&amp;&amp;(u=e.getElementById(i.r))&amp;&amp;(a[i.r]=u.querySelectorAll(&quot;stop&quot;));return a}(t,r,a),function(r){var i,u=e(r,t,qt);return u?&quot;c&quot;===u.t?X(u.v):&quot;g&quot;===u.t?(n[u.r]&amp;&amp;function(t,n){for(var e=0,r=t.length;e&lt;r;e++)t[e].setAttribute(&quot;stop-color&quot;,X(n[e]))}(n[u.r],u.v),(i=u.r)?&quot;url(#&quot;+i+&quot;)&quot;:&quot;none&quot;):&quot;none&quot;:&quot;none&quot;}}function qt(t,n,e){if(0===t)return n;if(1===t)return e;if(n&amp;&amp;e){var r=n.t;if(r===e.t)switch(n.t){case&quot;c&quot;:return{t:r,v:_(t,n.v,e.v)};case&quot;g&quot;:if(n.r===e.r)return{t:r,v:S(t,n.v,e.v),r:n.r}}}return m(t,n,e)}var Vt={blur:A,brightness:w,contrast:w,&quot;drop-shadow&quot;:function(t,n,e){return 0===t?n:1===t?e:{blur:A(t,n.blur,e.blur),offset:x(t,n.offset,e.offset),color:_(t,n.color,e.color)}},grayscale:w,&quot;hue-rotate&quot;:b,invert:w,opacity:w,saturate:w,sepia:w};function Lt(t,n,e){if(0===t)return n;if(1===t)return e;var r=n.length;if(r!==e.length)return m(t,n,e);for(var i,u=[],o=0;o&lt;r;o++){if(n[o].type!==e[o].type)return n;if(!(i=Vt[n[o].type]))return m(t,n,e);u.push({type:n.type,value:i(t,n[o].value,e[o].value)})}return u}var zt={blur:function(t){return t?function(n){t.setAttribute(&quot;stdDeviation&quot;,Q(n))}:null},brightness:function(t,n,e){return(t=Ut(e,n))?function(n){n=G(n),t.map((function(t){return t.setAttribute(&quot;slope&quot;,n)}))}:null},contrast:function(t,n,e){return(t=Ut(e,n))?function(n){var e=G((1-n)/2);n=G(n),t.map((function(t){t.setAttribute(&quot;slope&quot;,n),t.setAttribute(&quot;intercept&quot;,e)}))}:null},&quot;drop-shadow&quot;:function(t,n,e){var r=e.getElementById(n+&quot;-blur&quot;);if(!r)return null;var i=e.getElementById(n+&quot;-offset&quot;);if(!i)return null;var u=e.getElementById(n+&quot;-flood&quot;);return u?function(t){r.setAttribute(&quot;stdDeviation&quot;,Q(t.blur)),i.setAttribute(&quot;dx&quot;,G(t.offset.x)),i.setAttribute(&quot;dy&quot;,G(t.offset.y)),u.setAttribute(&quot;flood-color&quot;,X(t.color))}:null},grayscale:function(t){return t?function(n){t.setAttribute(&quot;values&quot;,H(function(t){return[.2126+.7874*(t=1-t),.7152-.7152*t,.0722-.0722*t,0,0,.2126-.2126*t,.7152+.2848*t,.0722-.0722*t,0,0,.2126-.2126*t,.7152-.7152*t,.0722+.9278*t,0,0,0,0,0,1,0]}(n)))}:null},&quot;hue-rotate&quot;:function(t){return t?function(n){return t.setAttribute(&quot;values&quot;,G(n))}:null},invert:function(t,n,e){return(t=Ut(e,n))?function(n){n=G(n)+&quot; &quot;+G(1-n),t.map((function(t){return t.setAttribute(&quot;tableValues&quot;,n)}))}:null},opacity:function(t,n,e){return(t=e.getElementById(n+&quot;-A&quot;))?function(n){return t.setAttribute(&quot;tableValues&quot;,&quot;0 &quot;+G(n))}:null},saturate:function(t){return t?function(n){return t.setAttribute(&quot;values&quot;,G(n))}:null},sepia:function(t){return t?function(n){return t.setAttribute(&quot;values&quot;,H(function(t){return[.393+.607*(t=1-t),.769-.769*t,.189-.189*t,0,0,.349-.349*t,.686+.314*t,.168-.168*t,0,0,.272-.272*t,.534-.534*t,.131+.869*t,0,0,0,0,0,1,0]}(n)))}:null}};var Dt=[&quot;R&quot;,&quot;G&quot;,&quot;B&quot;];function Ut(t,n){var e=Dt.map((function(e){return t.getElementById(n+&quot;-&quot;+e)||null}));return-1!==e.indexOf(null)?null:e}var Wt={fill:Nt,&quot;fill-opacity&quot;:Rt,stroke:Nt,&quot;stroke-opacity&quot;:Rt,&quot;stroke-width&quot;:Ft,&quot;stroke-dashoffset&quot;:{f:G,i:b},&quot;stroke-dasharray&quot;:Ct,opacity:Rt,transform:function(n,e,r,i){if(!(n=function(n,e){if(!n||&quot;object&quot;!==t(n))return null;var r=!1;for(var i in n)n.hasOwnProperty(i)&amp;&amp;(n[i]&amp;&amp;n[i].length?(n[i].forEach((function(t){t.e&amp;&amp;(t.e=e(t.e))})),r=!0):delete n[i]);return r?n:null}(n,i)))return null;var u=function(t,i,u){var o=arguments.length&gt;3&amp;&amp;void 0!==arguments[3]?arguments[3]:null;return n[t]?r(i,n[t],u):e&amp;&amp;e[t]?e[t]:o};return e&amp;&amp;e.a&amp;&amp;n.o?function(t){var e=r(t,n.o,Et);return jt.recomposeSelf(e,u(&quot;r&quot;,t,b,0)+e.a,u(&quot;k&quot;,t,x),u(&quot;s&quot;,t,x),u(&quot;t&quot;,t,x)).toString()}:function(t){return jt.recomposeSelf(u(&quot;o&quot;,t,Ot,null),u(&quot;r&quot;,t,b,0),u(&quot;k&quot;,t,x),u(&quot;s&quot;,t,x),u(&quot;t&quot;,t,x)).toString()}},&quot;#filter&quot;:function(t,n,e,r,i,u,o,a){if(!n.items||!t||!t.length)return null;var l=function(t,n){var e=(t=t.map((function(t){return t&amp;&amp;zt[t[0]]?(n.getElementById(t[1]),zt[t[0]](n.getElementById(t[1]),t[1],n)):null}))).length;return function(n){for(var r=0;r&lt;e;r++)t[r]&amp;&amp;t[r](n[r].value)}}(n.items,a);return l?(t=function(t,n){return t.map((function(t){return t.e=n(t.e),t}))}(t,r),function(n){l(e(n,t,Lt))}):null},&quot;#line&quot;:Tt,points:{f:H,i:M},d:Pt,r:Ft,&quot;#size&quot;:Z,&quot;#radius&quot;:$,_:function(t,n){if(Array.isArray(t))for(var e=0;e&lt;t.length;e++)this[t[e]]=n;else this[t]=n}};return function(t){!function(t,n){if(&quot;function&quot;!=typeof n&amp;&amp;null!==n)throw new TypeError(&quot;Super expression must either be null or a function&quot;);t.prototype=Object.create(n&amp;&amp;n.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),n&amp;&amp;u(t,n)}(o,t);var e=a(o);function o(){return n(this,o),e.apply(this,arguments)}return r(o,null,[{key:&quot;build&quot;,value:function(t){var n=l(i(o),&quot;build&quot;,this).call(this,t,Wt),e=n.el,r=n.options,u=n.player;return function(t,n,e){if(&quot;click&quot;===e.start){return void n.addEventListener(&quot;click&quot;,(function(){switch(e.click){case&quot;freeze&quot;:return!t._running&amp;&amp;t.reachedToEnd()&amp;&amp;(t.offset=0),t._running?t.pause():t.play();case&quot;restart&quot;:return t.offset&gt;0?t.restart():t.play();case&quot;reverse&quot;:var n=!t._rollingBack&amp;&amp;t._running,r=t.reachedToEnd();return n||r&amp;&amp;1===t.fill?(t.pause(),r&amp;&amp;(t.offset=t.duration-1),t._rollback()):r?t.restart():t.play();case&quot;none&quot;:default:return!t._running&amp;&amp;t.offset?t.restart():t.play()}}))}if(&quot;hover&quot;===e.start)return n.addEventListener(&quot;mouseenter&quot;,(function(){return t.reachedToEnd()?t.restart():t.play()})),void n.addEventListener(&quot;mouseleave&quot;,(function(){switch(e.hover){case&quot;freeze&quot;:return t.pause();case&quot;reset&quot;:return t.stop();case&quot;reverse&quot;:return t.pause(),t._rollback();case&quot;none&quot;:default:return}}));if(&quot;scroll&quot;===e.start)return void new W(n,e.scroll||25,(function(n){n?t.reachedToEnd()?t.restart():t.play():t.pause()}));t.play()}(u,e,r),u}}]),o}(D)})); __SVGATOR_PLAYER__.build({&quot;root&quot;:&quot;e7xpoug7ckgc1&quot;,&quot;animations&quot;:[{&quot;duration&quot;:3000,&quot;direction&quot;:1,&quot;iterations&quot;:0,&quot;fill&quot;:1,&quot;alternate&quot;:true,&quot;elements&quot;:{&quot;e7xpoug7ckgc5&quot;:{&quot;opacity&quot;:[{&quot;t&quot;:1500,&quot;v&quot;:1,&quot;e&quot;:[0.215,0.61,0.355,1]},{&quot;t&quot;:2000,&quot;v&quot;:0}]},&quot;e7xpoug7ckgc10&quot;:{&quot;opacity&quot;:[{&quot;t&quot;:1500,&quot;v&quot;:1,&quot;e&quot;:[0.215,0.61,0.355,1]},{&quot;t&quot;:2000,&quot;v&quot;:0}]},&quot;e7xpoug7ckgc16&quot;:{&quot;transform&quot;:{&quot;data&quot;:{&quot;t&quot;:{&quot;x&quot;:-240.27000427246094,&quot;y&quot;:-252.12000274658203}},&quot;keys&quot;:{&quot;o&quot;:[{&quot;t&quot;:1500,&quot;v&quot;:{&quot;x&quot;:240.27000427246094,&quot;y&quot;:252.12000274658203,&quot;type&quot;:&quot;corner&quot;},&quot;e&quot;:[0.215,0.61,0.355,1]},{&quot;t&quot;:1800,&quot;v&quot;:{&quot;x&quot;:239.86209840961587,&quot;y&quot;:380.5832773436242,&quot;type&quot;:&quot;corner&quot;}}],&quot;s&quot;:[{&quot;t&quot;:1500,&quot;v&quot;:{&quot;x&quot;:1,&quot;y&quot;:1},&quot;e&quot;:[0.215,0.61,0.355,1]},{&quot;t&quot;:1800,&quot;v&quot;:{&quot;x&quot;:0,&quot;y&quot;:0}}]}},&quot;opacity&quot;:[{&quot;t&quot;:1500,&quot;v&quot;:1,&quot;e&quot;:[0.215,0.61,0.355,1]},{&quot;t&quot;:1800,&quot;v&quot;:0}]},&quot;e7xpoug7ckgc27&quot;:{&quot;transform&quot;:{&quot;data&quot;:{&quot;k&quot;:{&quot;x&quot;:0,&quot;y&quot;:15.2},&quot;s&quot;:{&quot;x&quot;:1.171533095391922,&quot;y&quot;:1.171533095391922},&quot;t&quot;:{&quot;x&quot;:-418.3349914550781,&quot;y&quot;:-258.9200210571289}},&quot;keys&quot;:{&quot;o&quot;:[{&quot;t&quot;:600,&quot;v&quot;:{&quot;x&quot;:382.73164600000007,&quot;y&quot;:281.921047,&quot;type&quot;:&quot;corner&quot;}},{&quot;t&quot;:800,&quot;v&quot;:{&quot;x&quot;:313.5913124550782,&quot;y&quot;:264.23466405712895,&quot;type&quot;:&quot;corner&quot;}}]}}},&quot;e7xpoug7ckgc29&quot;:{&quot;d&quot;:[{&quot;t&quot;:900,&quot;v&quot;:[&quot;M&quot;,-13.95,0,&quot;C&quot;,-13.95,-9.499297697089645,-7.704372260139567,-17.2,0,-17.2,&quot;C&quot;,7.704372260139567,-17.2,13.95,-9.499297697089645,13.95,0,&quot;C&quot;,13.95,9.499297697089645,7.704372260139567,17.2,0,17.2,&quot;C&quot;,-7.704372260139567,17.2,-13.95,9.499297697089645,-13.95,0,&quot;Z&quot;]},{&quot;t&quot;:1200,&quot;v&quot;:[&quot;M&quot;,-13.95,0,&quot;C&quot;,-13.90212200000003,9.66531530291033,-7.817815260139529,17.200450999999976,-0.1134429999999611,17.200450999999976,&quot;C&quot;,7.590929260139606,17.200450999999976,13.73815099999997,9.461205302910372,13.95,0,&quot;C&quot;,13.844075999999983,-9.461204302910375,7.590929260139607,-17.330967000000005,-0.1134429999999611,-17.330967000000005,&quot;C&quot;,-7.817815260139528,-17.330967000000005,-13.859591000000034,-9.44500442291033,-13.95,0,&quot;Z&quot;]},{&quot;t&quot;:1500,&quot;v&quot;:[&quot;M&quot;,-13.95,0,&quot;C&quot;,-13.95,-9.499297697089645,-7.704372260139567,-17.2,0,-17.2,&quot;C&quot;,7.704372260139567,-17.2,13.95,-9.499297697089645,13.95,0,&quot;C&quot;,13.95,9.499297697089645,7.704372260139567,17.2,0,17.2,&quot;C&quot;,-7.704372260139567,17.2,-13.95,9.499297697089645,-13.95,0,&quot;Z&quot;]}]},&quot;e7xpoug7ckgc30&quot;:{&quot;d&quot;:[{&quot;t&quot;:900,&quot;v&quot;:[&quot;M&quot;,-13.95,0,&quot;C&quot;,-13.95,-9.499297697089645,-7.704372260139567,-17.2,0,-17.2,&quot;C&quot;,7.704372260139567,-17.2,13.95,-9.499297697089645,13.95,0,&quot;C&quot;,13.95,9.499297697089645,7.704372260139567,17.2,0,17.2,&quot;C&quot;,-7.704372260139567,17.2,-13.95,9.499297697089645,-13.95,0,&quot;Z&quot;]},{&quot;t&quot;:1200,&quot;v&quot;:[&quot;M&quot;,-13.95,0,&quot;C&quot;,-13.90212200000003,9.66531530291033,-7.817815260139529,17.200450999999976,-0.1134429999999611,17.200450999999976,&quot;C&quot;,7.590929260139606,17.200450999999976,13.73815099999997,9.461205302910372,13.95,0,&quot;C&quot;,13.844075999999983,-9.461204302910375,7.590929260139607,-17.330967000000005,-0.1134429999999611,-17.330967000000005,&quot;C&quot;,-7.817815260139528,-17.330967000000005,-13.859591000000034,-9.44500442291033,-13.95,0,&quot;Z&quot;]},{&quot;t&quot;:1500,&quot;v&quot;:[&quot;M&quot;,-13.95,0,&quot;C&quot;,-13.95,-9.499297697089645,-7.704372260139567,-17.2,0,-17.2,&quot;C&quot;,7.704372260139567,-17.2,13.95,-9.499297697089645,13.95,0,&quot;C&quot;,13.95,9.499297697089645,7.704372260139567,17.2,0,17.2,&quot;C&quot;,-7.704372260139567,17.2,-13.95,9.499297697089645,-13.95,0,&quot;Z&quot;]}]},&quot;e7xpoug7ckgc35&quot;:{&quot;opacity&quot;:[{&quot;t&quot;:1500,&quot;v&quot;:1,&quot;e&quot;:[0.25,1,0.25,1]},{&quot;t&quot;:2100,&quot;v&quot;:0}]},&quot;e7xpoug7ckgc36&quot;:{&quot;opacity&quot;:[{&quot;t&quot;:1500,&quot;v&quot;:1,&quot;e&quot;:[0.25,1,0.25,1]},{&quot;t&quot;:2100,&quot;v&quot;:0}]},&quot;e7xpoug7ckgc39&quot;:{&quot;transform&quot;:{&quot;data&quot;:{&quot;t&quot;:{&quot;x&quot;:-240.29000091552734,&quot;y&quot;:-202.12000274658203}},&quot;keys&quot;:{&quot;o&quot;:[{&quot;t&quot;:1500,&quot;v&quot;:{&quot;x&quot;:240.29000091552734,&quot;y&quot;:202.12000274658203,&quot;type&quot;:&quot;corner&quot;},&quot;e&quot;:[0.25,1,0.25,1]},{&quot;t&quot;:2100,&quot;v&quot;:{&quot;x&quot;:241.11228991552736,&quot;y&quot;:65.62005674658204,&quot;type&quot;:&quot;corner&quot;}}]}},&quot;opacity&quot;:[{&quot;t&quot;:1500,&quot;v&quot;:1,&quot;e&quot;:[0.25,1,0.25,1]},{&quot;t&quot;:2100,&quot;v&quot;:0}]},&quot;e7xpoug7ckgc45&quot;:{&quot;transform&quot;:{&quot;data&quot;:{&quot;t&quot;:{&quot;x&quot;:-256.0800018310547,&quot;y&quot;:-195.77499389648438}},&quot;keys&quot;:{&quot;o&quot;:[{&quot;t&quot;:1500,&quot;v&quot;:{&quot;x&quot;:241.61694683105463,&quot;y&quot;:334.89939989648457,&quot;type&quot;:&quot;corner&quot;},&quot;e&quot;:[0.025,0.52,0.345,1]},{&quot;t&quot;:2100,&quot;v&quot;:{&quot;x&quot;:242.98104283105457,&quot;y&quot;:185.22290289648458,&quot;type&quot;:&quot;corner&quot;}}],&quot;s&quot;:[{&quot;t&quot;:1500,&quot;v&quot;:{&quot;x&quot;:0.6335281147470395,&quot;y&quot;:0.6335281147470395},&quot;e&quot;:[0.5,0.005,0.32,1]},{&quot;t&quot;:2100,&quot;v&quot;:{&quot;x&quot;:1.0244315777380346,&quot;y&quot;:1.0244315777380346}}]}}},&quot;e7xpoug7ckgc61&quot;:{&quot;transform&quot;:{&quot;data&quot;:{&quot;t&quot;:{&quot;x&quot;:0.000028686523421583843,&quot;y&quot;:-0.0000018310546892053026}},&quot;keys&quot;:{&quot;o&quot;:[{&quot;t&quot;:1500,&quot;v&quot;:{&quot;x&quot;:251.38497131674075,&quot;y&quot;:174.46500366722267,&quot;type&quot;:&quot;corner&quot;},&quot;e&quot;:[0.025,0.52,0.285,0.995]},{&quot;t&quot;:2100,&quot;v&quot;:{&quot;x&quot;:367.07997131347656,&quot;y&quot;:122.33000183105469,&quot;type&quot;:&quot;corner&quot;}}]}},&quot;opacity&quot;:[{&quot;t&quot;:1600,&quot;v&quot;:0},{&quot;t&quot;:2100,&quot;v&quot;:1}]},&quot;e7xpoug7ckgc62&quot;:{&quot;transform&quot;:{&quot;data&quot;:{&quot;t&quot;:{&quot;x&quot;:-0.00002380371091703637,&quot;y&quot;:-0.0000152587890625}},&quot;keys&quot;:{&quot;o&quot;:[{&quot;t&quot;:1500,&quot;v&quot;:{&quot;x&quot;:251.3850238047653,&quot;y&quot;:174.46501708857744,&quot;type&quot;:&quot;corner&quot;},&quot;e&quot;:[0.025,0.52,0.285,0.995]},{&quot;t&quot;:2100,&quot;v&quot;:{&quot;x&quot;:366.79002380371094,&quot;y&quot;:275.25001525878906,&quot;type&quot;:&quot;corner&quot;}}]}}},&quot;e7xpoug7ckgc63&quot;:{&quot;transform&quot;:{&quot;data&quot;:{&quot;t&quot;:{&quot;x&quot;:0.0000021362304636340923,&quot;y&quot;:0}},&quot;keys&quot;:{&quot;o&quot;:[{&quot;t&quot;:1500,&quot;v&quot;:{&quot;x&quot;:251.384997863046,&quot;y&quot;:174.46500182718023,&quot;type&quot;:&quot;corner&quot;},&quot;e&quot;:[0.025,0.52,0.285,0.995]},{&quot;t&quot;:2100,&quot;v&quot;:{&quot;x&quot;:117.23999786376953,&quot;y&quot;:250,&quot;type&quot;:&quot;corner&quot;}}]}}},&quot;e7xpoug7ckgc64&quot;:{&quot;transform&quot;:{&quot;data&quot;:{&quot;t&quot;:{&quot;x&quot;:-0.0000025939941394881316,&quot;y&quot;:-0.0000016784668019909077}},&quot;keys&quot;:{&quot;o&quot;:[{&quot;t&quot;:1500,&quot;v&quot;:{&quot;x&quot;:251.3850025890925,&quot;y&quot;:174.46500350732373,&quot;type&quot;:&quot;corner&quot;},&quot;e&quot;:[0.025,0.52,0.285,0.995]},{&quot;t&quot;:2100,&quot;v&quot;:{&quot;x&quot;:131.78000259399414,&quot;y&quot;:78.7400016784668,&quot;type&quot;:&quot;corner&quot;}}]}}},&quot;e7xpoug7ckgc69&quot;:{&quot;transform&quot;:{&quot;data&quot;:{&quot;t&quot;:{&quot;x&quot;:-335.07997131347656,&quot;y&quot;:-122.35501098632812}},&quot;keys&quot;:{&quot;o&quot;:[{&quot;t&quot;:1500,&quot;v&quot;:{&quot;x&quot;:251.38500000260143,&quot;y&quot;:174.46500946303712,&quot;type&quot;:&quot;corner&quot;},&quot;e&quot;:[0.025,0.52,0.285,0.995]},{&quot;t&quot;:2100,&quot;v&quot;:{&quot;x&quot;:335.07997131347656,&quot;y&quot;:122.35501098632812,&quot;type&quot;:&quot;corner&quot;}}]}}},&quot;e7xpoug7ckgc70&quot;:{&quot;fill&quot;:[{&quot;t&quot;:1700,&quot;v&quot;:{&quot;t&quot;:&quot;g&quot;,&quot;v&quot;:[{&quot;r&quot;:14,&quot;g&quot;:29,&quot;b&quot;:83,&quot;a&quot;:1},{&quot;r&quot;:45,&quot;g&quot;:72,&quot;b&quot;:156,&quot;a&quot;:1},{&quot;r&quot;:133,&quot;g&quot;:126,&quot;b&quot;:255,&quot;a&quot;:1}],&quot;r&quot;:&quot;e7xpoug7ckgc70-fill&quot;},&quot;e&quot;:[0,0,0.375,0.91]},{&quot;t&quot;:2100,&quot;v&quot;:{&quot;t&quot;:&quot;g&quot;,&quot;v&quot;:[{&quot;r&quot;:255,&quot;g&quot;:220,&quot;b&quot;:39,&quot;a&quot;:1},{&quot;r&quot;:255,&quot;g&quot;:158,&quot;b&quot;:62,&quot;a&quot;:1},{&quot;r&quot;:255,&quot;g&quot;:138,&quot;b&quot;:126,&quot;a&quot;:1}],&quot;r&quot;:&quot;e7xpoug7ckgc70-fill&quot;}}]},&quot;e7xpoug7ckgc73&quot;:{&quot;opacity&quot;:[{&quot;t&quot;:1700,&quot;v&quot;:0.3,&quot;e&quot;:[0,0,0.375,0.91]},{&quot;t&quot;:2100,&quot;v&quot;:1}]},&quot;e7xpoug7ckgc74&quot;:{&quot;transform&quot;:{&quot;data&quot;:{&quot;t&quot;:{&quot;x&quot;:-306.5111389160156,&quot;y&quot;:-272.17852783203125}},&quot;keys&quot;:{&quot;o&quot;:[{&quot;t&quot;:1500,&quot;v&quot;:{&quot;x&quot;:259.4488181022406,&quot;y&quot;:199.90424927744138,&quot;type&quot;:&quot;corner&quot;},&quot;e&quot;:[0.025,0.52,0.285,0.995]},{&quot;t&quot;:2100,&quot;v&quot;:{&quot;x&quot;:306.5111389160156,&quot;y&quot;:272.17852783203125,&quot;type&quot;:&quot;corner&quot;}}]}}},&quot;e7xpoug7ckgc79&quot;:{&quot;transform&quot;:{&quot;data&quot;:{&quot;t&quot;:{&quot;x&quot;:-182.38999938964844,&quot;y&quot;:-153.69499969482422}},&quot;keys&quot;:{&quot;o&quot;:[{&quot;t&quot;:1500,&quot;v&quot;:{&quot;x&quot;:230.29271924840305,&quot;y&quot;:178.0665583906593,&quot;type&quot;:&quot;corner&quot;},&quot;e&quot;:[0.025,0.52,0.285,0.995]},{&quot;t&quot;:2100,&quot;v&quot;:{&quot;x&quot;:182.38999938964844,&quot;y&quot;:153.69499969482422,&quot;type&quot;:&quot;corner&quot;}}]}}},&quot;e7xpoug7ckgc83&quot;:{&quot;opacity&quot;:[{&quot;t&quot;:1500,&quot;v&quot;:0.3},{&quot;t&quot;:2100,&quot;v&quot;:1}]},&quot;e7xpoug7ckgc84&quot;:{&quot;transform&quot;:{&quot;data&quot;:{&quot;t&quot;:{&quot;x&quot;:-144.26499938964844,&quot;y&quot;:-246.7850112915039}},&quot;keys&quot;:{&quot;o&quot;:[{&quot;t&quot;:1500,&quot;v&quot;:{&quot;x&quot;:213.1776832763836,&quot;y&quot;:197.20149334278977,&quot;type&quot;:&quot;corner&quot;},&quot;e&quot;:[0.025,0.52,0.285,0.995]},{&quot;t&quot;:2100,&quot;v&quot;:{&quot;x&quot;:144.26499938964844,&quot;y&quot;:246.7850112915039,&quot;type&quot;:&quot;corner&quot;}}]}}},&quot;e7xpoug7ckgc93&quot;:{&quot;d&quot;:[{&quot;t&quot;:1500,&quot;v&quot;:[&quot;M&quot;,127.52,209.62,&quot;L&quot;,240.33,240.29,&quot;L&quot;,353.06,209.62,&quot;L&quot;,481.94,209.62,&quot;L&quot;,481.94,0.52,&quot;L&quot;,-1.36,0.52,&quot;L&quot;,-1.36,209.6,&quot;L&quot;,127.52,209.62,&quot;Z&quot;],&quot;e&quot;:[0,0,0.58,1]},{&quot;t&quot;:1600,&quot;v&quot;:[&quot;M&quot;,129.35526,299.60555,&quot;L&quot;,239.364251,329.944819,&quot;L&quot;,351.742929,299.296088,&quot;L&quot;,481.94,209.62,&quot;L&quot;,481.94,0.52,&quot;L&quot;,-1.36,0.52,&quot;L&quot;,-1.36,209.6,&quot;L&quot;,129.35526,299.60555,&quot;Z&quot;]},{&quot;t&quot;:1700,&quot;v&quot;:[&quot;M&quot;,3.655799,355.932089,&quot;L&quot;,237.605772,358.8687,&quot;L&quot;,478.407837,356.91096,&quot;L&quot;,481.94,209.62,&quot;L&quot;,481.94,0.52,&quot;L&quot;,-1.36,0.52,&quot;L&quot;,-1.36,209.6,&quot;L&quot;,3.655799,355.932089,&quot;Z&quot;]}]}}}],&quot;options&quot;:{&quot;start&quot;:&quot;scroll&quot;,&quot;hover&quot;:&quot;freeze&quot;,&quot;click&quot;:&quot;reverse&quot;,&quot;scroll&quot;:40,&quot;font&quot;:&quot;embed&quot;,&quot;exportedIds&quot;:&quot;unique&quot;,&quot;title&quot;:&quot;Unlock on white&quot;},&quot;animationSettings&quot;:{&quot;duration&quot;:3000,&quot;direction&quot;:1,&quot;iterations&quot;:0,&quot;fill&quot;:1,&quot;alternate&quot;:true}})")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthInfinite);
export default __webpack_public_path__ + "static/media/auth-infinite.f3161b6e3b43dd212d653784d40805bc.svg";
export { ForwardRef as ReactComponent };